export default "__VITE_ASSET__00b5283d__"